import isNodeEmpty from 'roosterjs-editor-dom/lib/utils/isNodeEmpty';
import { isStringNullOrWhiteSpace } from 'owa-localize';

/**
 * Determine if a content has visible HTML content in its body
 */
export function hasVisibleContent(content: string): boolean {
    if (isStringNullOrWhiteSpace(content)) {
        return false;
    }

    // Parse content to DOM and check for visible content
    try {
        // parseFromString can throw exception in IE
        const doc = new DOMParser().parseFromString(content, 'text/html');
        if (!doc || !doc.body) {
            // throw error if doc or body does not exist
            throw new Error();
        }
        return !isNodeEmpty(doc.body, true);
    } catch (error) {
        // default to assuming true rather than possibly hiding content by accident
        return true;
    }
}
